module.exports = __webpack_public_path__ + "static/media/hillshade-mobile.47f5bbee.png";